import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIGiornataLavoroTipo {

    getUrlDomain(nome_metodo) {

        let result = "";

        if (location.hostname == "localhost") {
            result = location.protocol + "//emtool.local/";
        }

        if (location.hostname != "localhost") {

            result = "https://companysupport.eu/";

        }

        return result + nome_metodo;


    }


    async initInsert(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);

        return axios.post(this.getUrlDomain("TwoRecruitTypeWorkDayInitInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async insertGiornata(giornata, user) {

        let formData = new FormData();

        formData.append("username", user);

        for (var key in giornata) {
            formData.append(key, giornata[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitTypeWorkDayInsApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initEdit(id, user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitTypeWorkDayInitEditApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }


    async updateGiornata(giornata, user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);

        for (var key in giornata) {
            formData.append(key, giornata[key]);
        }

        return axios.post(this.getUrlDomain("TwoRecruitTypeWorkDayUpdApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async deleteGiornata(user, id) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("id", id);


        return axios.post(this.getUrlDomain("TwoRecruitTypeWorkDayDelApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

    async initFilter(user, v_prod) {

        let formData = new FormData();

        formData.append("username", user);
        formData.append("v_prod", v_prod);


        return axios.post(this.getUrlDomain("TwoRecruitTypeWorkDayInitFilterApi"), formData, { 'Content-Type': 'multipart/form-data' });

    }

}

export default new APIGiornataLavoroTipo({
    url: "https://services.ebadge.it/public/api/"
})
